import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SevenPointStar } from "@/components/Star";

export default function DonateCancel() {
  return (
    <main data-testid="donate-cancel-page" className="flex min-h-screen flex-col items-center justify-center bg-jordan-sand px-6 text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="flex max-w-xl flex-col items-center"
      >
        <SevenPointStar className="mb-10 h-16 w-16 text-jordan-ink/20" />
        <h1 className="font-display text-4xl font-black uppercase tracking-tight sm:text-6xl" data-testid="donate-cancel-title">
          No worries
        </h1>
        <p className="mt-6 max-w-md leading-relaxed text-jordan-mute" data-testid="donate-cancel-message">
          Your donation was cancelled and nothing was charged. The door of the madafa is
          always open whenever you are ready.
        </p>
        <Link
          to="/#donate"
          data-testid="donate-cancel-retry-link"
          className="mt-12 border border-jordan-red bg-jordan-red px-8 py-4 font-display text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-jordan-ink hover:border-jordan-ink"
        >
          Try again
        </Link>
      </motion.div>
    </main>
  );
}
